import React from "react";
import { Link } from "react-router-dom";
import { activeManagers, formerManagers } from "./managersData";
import "./HomePage.css";

const headers = [
  "Manager",
  "Team Name",
  "Alternate Names",
  "Total W-L Record | Championship Record",
  "2023-2024",
  "2024-2025",
  "2025-2026",
];

const Managers = () => {
  // Helper to get field value by header
  const getFieldValue = (manager, header) => {
    switch (header) {
      case "Manager":
        return (
          <Link
            to={`/managers/${manager.manager.toLowerCase().replace(/\s+/g, "")}`}
            className="manager-name"
          >
            {manager.manager}
          </Link>
        );
      case "Team Name":
        return manager.teamName;
      case "Alternate Names":
        return manager.altNames;
      case "Total W-L Record | Championship Record":
        return manager.totalRecord;
      case "2023-2024":
      case "2024-2025":
      case "2025-2026":
        return manager.seasonRecords[header] || "-";
      default:
        return "-";
    }
  };

  return (
    <div className="homepage-container">
      {/* Header */}
      <header className="header">
        <nav className="nav-bar">
          <Link to="/" className="nav-link">
            Home
          </Link>
          <Link to="/managers" className="nav-link">
            Managers
          </Link>
          <Link to="/seasons" className="nav-link">
            Seasons
          </Link>
          <Link to="/league-settings" className="nav-link">
            League Settings
          </Link>
        </nav>
      </header>

      {/* Active Managers */}
      <h1 className="footballin-title" style={{ marginTop: "1rem" }}>
        Active Managers
      </h1>
      <div className="managers-grid">
        {/* Headers */}
        {headers.map((header, i) => (
          <div key={i} className="grid-header">
            {header}
          </div>
        ))}
        {/* Rows */}
        {activeManagers.map((manager, rowIndex) =>
          headers.map((header, colIndex) => (
            <div key={`${rowIndex}-${colIndex}`} className="grid-cell">
              {getFieldValue(manager, header)}
            </div>
          ))
        )}
      </div>

      <hr style={{ margin: "3rem 0" }} />

      {/* Former Managers */}
      <h1 className="footballin-title">Former Managers</h1>
      <div className="managers-grid">
        {/* Headers */}
        {headers.map((header, i) => (
          <div key={i} className="grid-header">
            {header}
          </div>
        ))}
        {/* Rows */}
        {formerManagers.map((manager, rowIndex) =>
          headers.map((header, colIndex) => (
            <div key={`${rowIndex}-${colIndex}`} className="grid-cell">
              {getFieldValue(manager, header)}
            </div>
          ))
        )}
      </div>

      {/* Footer */}
      <footer className="footer">Created by Nick Criss ⚡️</footer>
    </div>
  );
};

export default Managers;
